import { usePaywall, isActivationRequired } from "@/contexts/PaywallContext";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Hook that returns a wrapped API runner: on 402 activation errors,
 * opens the paywall and retries the call after successful payment.
 */
export function usePaywallGuard() {
  const { show } = usePaywall();
  const { checkAuth } = useAuth();

  return async (apiCall, featureName = "this feature") => {
    try {
      return await apiCall();
    } catch (err) {
      if (isActivationRequired(err)) {
        return new Promise((resolve, reject) => {
          show(featureName, async () => {
            await checkAuth();
            try {
              const result = await apiCall();
              resolve(result);
            } catch (e) { reject(e); }
          });
        });
      }
      throw new Error(formatApiError(err.response?.data?.detail) || err.message);
    }
  };
}
